export default [
    { label: "Name", prop: "name", type: "text", group: "main", inputClass: "diagonal-wrap" },
    { label: "Preparation time (minutes)", prop: "prep_time", type: "number", group: "main" },
    { label: "Servings", prop: "servings", type: "number", group: "main" },
]
